import { render, staticRenderFns } from "./properties-block-footer.vue?vue&type=template&id=3f757a5e&scoped=true"
import script from "./properties-block-footer.vue?vue&type=script&lang=js"
export * from "./properties-block-footer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f757a5e",
  null
  
)

export default component.exports